import { render, staticRenderFns } from "./SourceEditFormFields.vue?vue&type=template&id=0fd009cd&scoped=true"
import script from "./SourceEditFormFields.vue?vue&type=script&lang=js"
export * from "./SourceEditFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd009cd",
  null
  
)

export default component.exports